export const FETCH_RATES_GRAPH_REQUEST = 'FETCH_RATES_GRAPH_REQUEST';
export const FETCH_RATES_GRAPH_SUCCESS = 'FETCH_RATES_GRAPH_SUCCESS';
export const FETCH_RATES_GRAPH_FAILURE = 'FETCH_RATES_GRAPH_FAILURE';
export const FETCH_RATES_MB_GRAPH_REQUEST = 'FETCH_RATES_MB_GRAPH_REQUEST';
export const FETCH_RATES_MB_GRAPH_SUCCESS = 'FETCH_RATES_MB_GRAPH_SUCCESS';
export const FETCH_RATES_MB_GRAPH_FAILURE = 'FETCH_RATES_MB_GRAPH_FAILURE';
